import React, {useState} from "react";
import './BottomCardInt.css';


function BottomCardInt(prop){
    let item = prop?.cardData;
    return(
        <div className="carouselCard" style={{background:`url(${item?.icon}) no-repeat`,backgroundSize:"100% 100%"}}>
            <div className="carouselCardWrapper">
                <h4>{item?.title}</h4>
                <p><img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/aug-15-points-group.png" alt="pointsgroup" width={28} /> {item?.subTitle}</p>
                <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/aug-15-card-forward.png" alt="next" width={30} height={30} />
            </div>
        </div>
    )
}

export default BottomCardInt;


/*
<button className="carouselCardBtn" onClick={() => {
    directDeepLink(item?.deeplink, SOURCE_HOME);
    window.open(item?.deeplink?.paramOne);}}>
    <img src={item?.icon} alt="next" width={30} height={30} />
</button>*/
